import { render, staticRenderFns } from "./newCars.vue?vue&type=template&id=a79e0272&scoped=true&"
import script from "./newCars.vue?vue&type=script&lang=js&"
export * from "./newCars.vue?vue&type=script&lang=js&"
import style0 from "./newCars.vue?vue&type=style&index=0&id=a79e0272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79e0272",
  null
  
)

export default component.exports